<template>
	<div class="blackscreen">
		<div class="add-to">
			<i class="fas">
				<img src="@/assets/images/playlist_add-24px.svg" width="50px" alt="Ícone salvar" />
			</i>
			<span class="titulo">Adicionar à coleção:</span>

			<div class="search-bar">
				<label>
					<input
						type="text"
						name="search-bar"
						v-model="params.termo"
						@keyup.enter="getPaginaAtual"
						placeholder="Filtre pelo nome da coleção"
					/>
					<i class="fas fa-search" @click="getPaginaAtual"></i>
				</label>
			</div>

			<div class="table-wrapper">
				<SubColecoes
					v-for="(subColecao, index) in colecoes"
					:key="(index + 1)"
					:subColecoes="subColecao.subColecoes"
					:subColecao="subColecao"
				></SubColecoes>
			</div>

			<div class="btns">
				<div class="button criar" @click="cadastro">
					<span class="material-icons">playlist_add</span> Criar nova coleção
				</div>
				<div class="button descartar" @click="descartar">Descartar</div>
				<div class="button salvar" @click="adicionar">Salvar</div>
			</div>
		</div>
		<CadastrarColecao @close="boxClose" @criar="createColection" v-if="close" />
	</div>
</template>

<script>
import { colecoes } from './../../../services/colecoes'
import { objetos } from './../../../services/objetos'
import SubColecoes from './inc/SubColecoes'
import CadastrarColecao from '@/components/views/colecoes/inc/CadastrarColecao'
export default {
	name: 'SalvarNaColecao',
	components: { SubColecoes, CadastrarColecao },
	data () {
		return {
			params: {
				nome: '',
				termo: ''
			},
			dados: {
				nome: '',
				descricao: ''
			},
			colecoes: [],
			paginaAtual: 1,
			loadContent: true,
			totalItens: 20,
			id: null,
			close: false,
			boxCadastro: true
		}
	},
	props: { objetoId: String },
	methods: {
		async createColection (dados) {
			const colecao = await colecoes.create(dados)

			if (colecao.status === 200) {
				dados = {}
				this.close = false
				this.getPaginaAtual()
				window.notificationEM.open(
					'',
					'Coleção cadastrada com Sucesso !',
					'success'
				)
			} else {
				window.notificationEM.open(
					'',
					`Coleção não cadastrada - Erro: ${colecao.status}`,
					'error'
				)
			}
		},
		boxClose (close) {
			this.close = close
		},
		descartar () {
			this.boxCadastro = !this.boxCadastro
			this.$emit('boxCreate', this.boxCadastro)
		},
		async adicionar () {
			const selColecoes = []
			let colNomes = ''

			const colecoes = this.colecoes
			// let buscarColecaoRaiz = this.buscarColecaoRaiz
			// busca recursiva em arvore
			this.colecoes.filter(function f (o) {
				if (o.checked) {
					selColecoes.push(o)

					let link = []

					if (o.colecaoId !== null) {
						const result = JSON.parse(JSON.stringify(colecoes)).filter(function search (a) {
							if (a.id === o.colecaoId) {
								return true
							}

							if (!Array.isArray(a.subColecoes)) {
								return false
							}

							const children = a.subColecoes.filter(search)
							if (children.length) {
								a.children = children
								return true
							}
						})

						link = [result[0].id, result[0].nome]
					} else {
						link = [o.id, o.nome]
					}

					if (colNomes !== '') {
						colNomes += `<a href="/visualizarColecao?id=${link[0]}"> ${link[1]}</a>`
					} else {
						colNomes = `<a href="/visualizarColecao?id=${link[0]}"> ${link[1]}</a>`
					}

					return true
				}

				if (o.subColecoes) {
					return o.subColecoes.filter(f).length
				}
			})

			objetos
				.updateColecoes(this.objetoId, { colecoes: selColecoes })
				.then(res => {
					selColecoes.map(c => delete c.checked)
					this.$emit('boxCreate', !this.boxCadastro)

					window.notificationEM.open(
						'',
						`Objeto adicionado com sucesso em: ${colNomes}`,
						'success'
					)
				})
				.catch(res => {
					window.notificationEM.open('', res.response.data.msg, 'error')
				})
		},
		async getPaginaAtual () {
			this.params = {
				usuario: this.$auth.user().id,
				objetos: this.objetoId,
				termo: this.params.termo
			}

			if (this.params && this.params.skip) {
				this.paginaAtual = parseInt(this.params.skip)
				this.params.skip = parseInt(this.params.skip) - 1
			} else {
				this.paginaAtual = 1
				this.params.skip = 0
			}

			this.colecoes = []

			const colecoesSelecionadas = await colecoes
				.find(this.params)
				.then(res => {
					return res.data
				})
				.catch(err => console.log(err))
			await colecoes
				.findInTree(this.params)
				.then(res => {
					// busca recursiva em arvore
					res.data.filter(function f (o) {
						if (colecoesSelecionadas.find(c => c.id === o.id)) {
							o.checked = true
							return true
						}
						if (o.subColecoes) {
							return o.subColecoes.filter(f).length
						}
					})

					this.colecoes = res.data
					if (this.colecoes && this.colecoes.length > 0) {
						this.totalItens = res.data[0].total
					}
				})
				.catch(err => console.log(err))
		},
		cadastro () {
			this.close = !this.close
		}
	},
	async created () {
		this.getPaginaAtual()
	}
}
</script>

<style lang="scss" scoped>
.blackscreen {
	position: fixed;
	top: 0;
	left: 0;
	z-index: 2;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100vw;
	height: 100vh;
	background-color: #0007;

	&.blackscreen {
		z-index: 3;
	}
}

.add-to {
	position: relative;
	background-color: #fefefe;
	display: flex;
	flex-direction: column;
	padding: 20px 30px 30px 30px;
	border-radius: 5px;
	width: 60vw;

	i {
		color: #052354;
		font-size: 43px;
		margin-bottom: 18px;
	}

	.titulo {
		color: #052354;
		font-weight: 700;
		font-size: 20px;
		margin-bottom: 11px;
	}

	.search-bar {
		position: absolute;
		top: 28px;
		right: 45px;

		label {
			position: relative;
			display: flex;
			align-items: center;
			width: 500px;
			height: 35px;
			border: 1px solid #59708f;
			border-radius: 100px;
			background-color: #f8f9fb;

			input {
				width: 100%;
				height: 100%;
				padding: 0 40px 0 20px;
				border: none;
				border-radius: 100px;
				color: #011536;
				font-family: "Roboto Condensed", "Roboto", sans-serif;

				&::placeholder {
					opacity: 1;
					color: #011536;
				}

				& + i {
					position: absolute;
					top: 8px;
					right: 13px;
					cursor: pointer;
					font-size: 16px;
				}
			}
		}
	}

	.nome {
		color: #ebecef;
		border: 1px solid;
		border-radius: 5px;
		height: 40px;
		margin-bottom: 11px;

		input {
			background-color: #f8f9fb;
			color: #8b94a7;
			border: none;
			border-radius: 5px;
			width: 100%;
			height: 100%;
			padding: 10px;
			font: Condensed 16px Roboto;
		}
	}

	.descricao {
		color: #ebecef;
		border: 1px solid;
		border-radius: 5px;
		height: 128px;
		margin-bottom: 16px;

		textarea {
			background-color: #f8f9fb;
			color: #8b94a7;
			border: none;
			border-radius: 5px;
			width: 100%;
			height: 100%;
			padding: 10px;
			font: Condensed 16px Roboto;
		}
	}

	.btns {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		height: 90px;
		margin: 20px -30px -30px -30px;
		padding: 0 30px;
		border-radius: 0 0 5px 5px;
		background-color: #f8f9fb;

		.button {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 120px;
			height: 45px;
			padding: 0 20px;
			margin-right: 10px;
			text-transform: uppercase;
			font-weight: 700;
			cursor: pointer;
			transition: 0.333s all;

			&.criar {
				position: absolute;
				left: 30px;
				width: unset;
				border: none;
				border-radius: 5px;
				background-color: #e2e41a;
				color: #001737;

				&:hover {
					background-color: #d1d25f;
					border-color: transparent;
				}
			}

			&.descartar {
				background-color: #ffffff;
				border-radius: 5px;
				border: 1px solid;
				border-color: #06162b;
				color: #06162b;

				&:hover {
					background-color: #e64141;
					color: #fff;
					border-color: transparent;
				}
			}

			&.salvar {
				background-color: #00659d;
				border-radius: 5px;
				border: 1px solid;
				color: #ffffff;

				&:hover {
					background-color: #4191e6;
					color: #fff;
					border-color: transparent;
				}
			}
		}
		.criar_colecao {
			height: 40px;
			width: 230px;
			color: #fff;
			border: none;
			border-radius: 5px;
			padding: 0 10px;
			font-weight: 700;
			font-size: 1em;
			cursor: pointer;
			outline: none;
			display: flex;
			align-items: center;
			justify-content: center;

			i {
				font-size: 1.6em;
				margin-right: 5px;
			}

			background-color: $yellow-color;
			color: $main-color;
		}
	}
}

.table-wrapper {
	width: 100%;
	height: 55vh;
	padding-right: 10px;
	scrollbar-width: thin;
	overflow: auto;
	color: #000;
}
</style>
